import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem
  width: 78%;
  height: 100%;
  padding: ${() =>
    `${viewSizeCalculator(0.75)} ${viewSizeCalculator(
      0.75,
    )} ${viewSizeCalculator(0.75)} ${viewSizeCalculator(0.75)}`};

  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  background-color: #fff;

  box-shadow: 0rem 0.0625rem 0.3125rem 0rem #3333331a;
  transition: width 400ms ease-in-out;
`;

export const ScrollWrapper = styled.div`
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(2.5)}`};
  padding: ${() => `${viewSizeCalculator(2)}`} 0;

  overflow-x: auto;
  position: relative;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: ${() => `${viewSizeCalculator(0.375)}`}; // Width of the vertical scrollbar
    //height: ${() => `${viewSizeCalculator(0.375)}`}; // Height of the horizontal scrollbar
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1; // Light gray background for the scrollbar track
    border-radius: ${() => `${viewSizeCalculator(0.375)}`}; // Rounded corners for the track
  }

  &::-webkit-scrollbar-thumb {
    background: #3333334d; // Light gray color for the scrollbar thumb
    border-radius: ${() => `${viewSizeCalculator(0.375)}`}; // Rounded corners for the thumb
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #33333380; // Darker gray color when hovering over the scrollbar thumb
  }
`;

export const Section = styled.div`
  // margin-top: 20px;
  // border: 1px solid red;
  position: relative;
  // padding: 1px 20px;
  padding: ${() => `${viewSizeCalculator(0.063)} ${viewSizeCalculator(1.25)}`};
  margin: ${() => `${viewSizeCalculator(0)} ${viewSizeCalculator(0.75)}`};
`;

export const RoundedBorder = styled.div`
  position: absolute;
  left: 0;
  width: ${() => `${viewSizeCalculator(0.4)}`};
  height: 100%; /* Adjust height */
  background-color: #f99c89; /* Light red */
  border-radius: ${() => `${viewSizeCalculator(3.125)}`}; /* Fully rounded */
  margin-top: -1px;
`;

export const SectionTitle = styled.h2`
  margin-bottom: ${() => `${viewSizeCalculator(1.5)}`}; // 1.5rem
  font-size: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  font-weight: 700;
  font-family: Inter;
  margin-top: ${() => `${viewSizeCalculator(0.5)}`}; // 0.5rem
  line-height: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  color: #333333;
  opacity: 78%;
`;

export const SectionSpan = styled(SectionTitle)`
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 1.25rem
  font-weight: 700;
  display: inline-block;
`

export const CategoryHeader = styled.h2`
  margin-bottom: ${() => `${viewSizeCalculator(0.75)}`}; // 0.75rem
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  font-weight: 700;
  font-family: Inter;
  line-height: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  color: #333333;
  opacity: 30%;
`;

export const CategoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(1.5)}`};
  margin-bottom: ${() => `${viewSizeCalculator(0.5)}`}; // 0.5rem
`;

export const Category = styled.div``;

export const CategoriesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${() => `${viewSizeCalculator(1.5)}`};
  margin-bottom: ${() => `${viewSizeCalculator(0.5)}`}; // 0.5rem
`;

export const DetailRow = styled.div`
  width: ${() => `${viewSizeCalculator(17.0)}`}; //115.5
  // height: ${() => `${viewSizeCalculator(2.5)}`};
  // border: 1px solid red;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  gap: ${() => `${viewSizeCalculator(0.25)}`};
`;

export const Label = styled.span`
  font-size: ${() => `${viewSizeCalculator(0.913)}`}; // 0.813rem
  font-weight: 500;
  font-family: Inter;
  // margin-top: ${() => `${viewSizeCalculator(0.5)}`}; // 0.5rem
  line-height: ${() => `${viewSizeCalculator(1.125)}`}; // 1.125rem
  color: #858585;
`;

export const Value = styled.span`
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  font-weight: 700;
  font-family: Inter;
  margin-top: ${() => `${viewSizeCalculator(0.5)}`}; // 0.5rem
  line-height: ${() => `${viewSizeCalculator(1.125)}`}; // 1.125rem
  // color: ${({ value, dontChangeColor }) => (value?.toString().startsWith('-') && !dontChangeColor ? '#FF0000' : '#000000')};
  color: ${({ isNegative, isPlaceholder }) => 
    isPlaceholder ? '#333' : isNegative ? '#FF0000' : '#000000'};
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
`;

export const SpanValue = styled(Value)`
  font-size: ${() => `${viewSizeCalculator(0.875)}`}; // 1rem
  font-weight: 600;
  color: ${({ isNegative, isPlaceholder }) => 
    isPlaceholder ? '#333' : isNegative ? '#FF0000' : '#000000'};
`;

export const AnchorValue = styled.a`
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  font-weight: 700;
  font-family: Inter;
  margin-top: ${() => `${viewSizeCalculator(0.5)}`}; // 0.5rem
  line-height: ${() => `${viewSizeCalculator(1.25)}`}; // 1.125rem
  color: #cf6c58;
  display: inline-block;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%; /* Ensures it doesn't overflow the wrapper */

  &:hover {
    color: #f99c89;
  }
`;

export const TagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${() => `${viewSizeCalculator(1)}`};
  margin-bottom: ${() => `${viewSizeCalculator(0.5)}`}; // 0.5rem
`;

export const Tag = styled.span`
  background: #f5f5f5;
  padding: ${() => `${viewSizeCalculator(0.5)} ${viewSizeCalculator(1)}`};
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  font-size: ${() => `${viewSizeCalculator(0.875)}`};
  line-height: ${() => `${viewSizeCalculator(1)}`};
  font-weight: 400;
  color: #333;
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.625)}`};

  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`}; // 1.5rem;
    height: ${() => `${viewSizeCalculator(1.5)}`}; // 1.5rem;
  }
`;

export const SpanTag = styled.span`
  margin-top: ${() => `${viewSizeCalculator(0.15)}`};
`;

export const TagWithBadge = styled(Tag)`
  padding: ${() => `${viewSizeCalculator(0.3)} ${viewSizeCalculator(0.375)}
                    ${viewSizeCalculator(0.3)} ${viewSizeCalculator(1)}`};
  gap: ${() => `${viewSizeCalculator(1)}`};
`;

export const Pill = styled.span`
  min-width: ${() => `${viewSizeCalculator(2.938)}`};
  width: fit-content;
  height: ${() => `${viewSizeCalculator(1.375)}`};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${() => `${viewSizeCalculator(0.25)}`};
  padding: ${() => `${viewSizeCalculator(0)} ${viewSizeCalculator(0.75)}`};
  font-size: ${() => `${viewSizeCalculator(0.625)}`};
  font-weight: 500;
  text-align: center;
  border-radius: ${() => `${viewSizeCalculator(1)}`};
  color: white;
  background-color: ${(props) => {
    const value = props.status;

    // Handle empty / missing values
    if (value === "-" || value === "None" || value === null || value === undefined) {
      return "#A0A0A0"; // gray pill
    }

    // Handle boolean values (nccn / c4qi)
    if (typeof value === "boolean") {
      return value ? "#61C676" : "#F34D4D"; // green / red
    }

    // Handle numeric-like values
    const num = parseFloat(value);
    if (!isNaN(num)) {
      if (num <= 2) return "#F34D4D";   // red
      if (num > 2 && num < 4) return "#F6B51C"; // yellow
      return "#61C676"; // green
    }

    // Default fallback
    return "#A0A0A0";
  }};

  span {
    display: inline-flex;
    align-items: center;
    margin-top: 0;
  }
`;

export const PillNumber = styled.span`
  min-width: ${() => `${viewSizeCalculator(2.938)}`};
  width: fit-content;
  height: ${() => `${viewSizeCalculator(1.375)}`};
  display: flex;
  flex-direction: column;
  // border: 1px solid red;
  justify-content: center;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.625)}`};
  padding: ${() => `${viewSizeCalculator(0.125)} ${viewSizeCalculator(0.75)}`};
  font-size: ${() => `${viewSizeCalculator(0.625)}`};
  line-height: ${() => `${viewSizeCalculator(1.125)}`};
  font-weight: 600;
  text-align: center;
  border-radius: ${() => `${viewSizeCalculator(1)}`};
  color: white;
  // background-color: ${(props) => (props.status ? "#61C676" : "#F34D4D")};
  background: ${(props) => props.bg};
`;

export const QualityCareDetailRow = styled.div`
  // width: ${() => `${viewSizeCalculator(15.5)}`};
  // height: ${() => `${viewSizeCalculator(2.5)}`};
  display: flex;
  // justify-content: space-between;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.25)}`};
`;

export const QualityCareTitle = styled.span`
  // width: ${() => `${viewSizeCalculator(12.5)}`};
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 0.875rem
  font-weight: 700;
  font-family: Inter;
  // margin-top: ${() => `${viewSizeCalculator(0.5)}`}; // 0.5rem
  line-height: ${() => `${viewSizeCalculator(2)}`}; // 2rem
  color: #333333;
`;

export const QualityCareValue = styled.span`
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 0.875rem
  font-weight: 600;
  font-family: Inter;
  // margin-top: ${() => `${viewSizeCalculator(0.5)}`}; // 0.5rem
  line-height: ${() => `${viewSizeCalculator(1.125)}`}; // 2rem
  color: #333333;
`;

export const QualityCareContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(1)}`};
  margin-top: ${() => `${viewSizeCalculator(1.5)}`};
  margin-bottom: ${() => `${viewSizeCalculator(0.5)}`}; // 0.5rem
`;

export const MapContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${viewSizeCalculator(25)}, 1fr)); 
  row-gap: ${() => `${viewSizeCalculator(3)}`};
  column-gap: ${() => `${viewSizeCalculator(1)}`};
  padding: ${() => `0 ${viewSizeCalculator(0.5)} ${viewSizeCalculator(1.5)} 0`};
`;